import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { months } from '../../assets/templates';
import FlipSwitch from './FlipSwitch';
/* eslint no-underscore-dangle: ["off"] */

const TimeSlots = ({
  entriesValues,
  setEntriesValue,
  exitValues,
  setExitValues,
  workedDays,
  setWorkedDays,
  isDisabled,
  setIsDisabled,
}) => (
  <table className="time-slots-container item-container appear">
    <thead>
      <tr>
        <td>
          <p style={{ textAlign: 'left' }}>Dia</p>
        </td>
        <td>
          <p>Dia laboral</p>
        </td>
        <td>
          <p>Horario de entrada</p>
        </td>
        <td>
          <p>Horario de salida</p>
        </td>
        <td>
          <p>{`Mes: ${months[moment()._locale._months.indexOf(moment().format('MMMM'))]}`}</p>
        </td>
      </tr>
    </thead>
    <tbody>
      <tr className="time-slots-wrapper">
        <td><p>Lunes</p></td>
        <td>
          <FlipSwitch
            isOn={isDisabled.monday}
            setIsOn={(value) => setIsDisabled((prevState) => ({ ...prevState, monday: value }))}
          />
        </td>
        <td>
          <input
            name="entry-work-time"
            type="time"
            disabled={isDisabled.monday}
            value={entriesValues.monday}
            onChange={(e) => setEntriesValue((prevState) => ({ ...prevState, monday: e.target.value }))}
          />
        </td>
        <td>
          <input
            name="exit-work-time"
            type="time"
            disabled={isDisabled.monday}
            value={exitValues.monday}
            onChange={(e) => setExitValues((prevState) => ({ ...prevState, monday: e.target.value }))}
          />
        </td>
        <td style={{ textAlign: 'center' }}>
          <input
            name="worked-days"
            type="number"
            style={{ maxWidth: '100px' }}
            disabled={isDisabled.monday}
            value={workedDays.monday || ''}
            onChange={(e) => setWorkedDays((prevState) => ({ ...prevState, monday: Number(e.target.value) }))}
          />
        </td>
      </tr>
      <tr className="time-slots-wrapper">
        <td><p>Martes</p></td>
        <td>
          <FlipSwitch
            isOn={isDisabled.tuesday}
            setIsOn={(value) => setIsDisabled((prevState) => ({ ...prevState, tuesday: value }))}
          />
        </td>
        <td>
          <input
            name="entry-work-time"
            type="time"
            disabled={isDisabled.tuesday}
            value={entriesValues.tuesday}
            onChange={(e) => setEntriesValue((prevState) => ({ ...prevState, tuesday: e.target.value }))}
          />
        </td>
        <td>
          <input
            name="exit-work-time"
            type="time"
            disabled={isDisabled.tuesday}
            value={exitValues.tuesday}
            onChange={(e) => setExitValues((prevState) => ({ ...prevState, tuesday: e.target.value }))}
          />
        </td>
        <td style={{ textAlign: 'center' }}>
          <input
            name="worked-days"
            type="number"
            style={{ maxWidth: '100px' }}
            disabled={isDisabled.tuesday}
            value={workedDays.tuesday || ''}
            onChange={(e) => setWorkedDays((prevState) => ({ ...prevState, tuesday: Number(e.target.value) }))}
          />
        </td>
      </tr>
      <tr className="time-slots-wrapper">
        <td><p>Miercoles</p></td>
        <td>
          <FlipSwitch
            isOn={isDisabled.wednesday}
            setIsOn={(value) => setIsDisabled((prevState) => ({ ...prevState, wednesday: value }))}
          />
        </td>
        <td>
          <input
            name="entry-work-time"
            type="time"
            disabled={isDisabled.wednesday}
            value={entriesValues.wednesday}
            onChange={(e) => setEntriesValue((prevState) => ({ ...prevState, wednesday: e.target.value }))}
          />
        </td>
        <td>
          <input
            name="exit-work-time"
            type="time"
            disabled={isDisabled.wednesday}
            value={exitValues.wednesday}
            onChange={(e) => setExitValues((prevState) => ({ ...prevState, wednesday: e.target.value }))}
          />
        </td>
        <td style={{ textAlign: 'center' }}>
          <input
            name="worked-days"
            type="number"
            style={{ maxWidth: '100px' }}
            disabled={isDisabled.wednesday}
            value={workedDays.wednesday || ''}
            onChange={(e) => setWorkedDays((prevState) => ({ ...prevState, wednesday: Number(e.target.value) }))}
          />
        </td>
      </tr>
      <tr className="time-slots-wrapper">
        <td><p>Jueves</p></td>
        <td>
          <FlipSwitch
            isOn={isDisabled.thursday}
            setIsOn={(value) => setIsDisabled((prevState) => ({ ...prevState, thursday: value }))}
          />
        </td>
        <td>
          <input
            name="entry-work-time"
            type="time"
            disabled={isDisabled.thursday}
            value={entriesValues.thursday}
            onChange={(e) => setEntriesValue((prevState) => ({ ...prevState, thursday: e.target.value }))}
          />
        </td>
        <td>
          <input
            name="exit-work-time"
            type="time"
            disabled={isDisabled.thursday}
            value={exitValues.thursday}
            onChange={(e) => setExitValues((prevState) => ({ ...prevState, thursday: e.target.value }))}
          />
        </td>
        <td style={{ textAlign: 'center' }}>
          <input
            name="worked-days"
            type="number"
            style={{ maxWidth: '100px' }}
            disabled={isDisabled.thursday}
            value={workedDays.thursday || ''}
            onChange={(e) => setWorkedDays((prevState) => ({ ...prevState, thursday: Number(e.target.value) }))}
          />
        </td>
      </tr>
      <tr className="time-slots-wrapper">
        <td><p>Viernes</p></td>
        <td>
          <FlipSwitch
            isOn={isDisabled.friday}
            setIsOn={(value) => setIsDisabled((prevState) => ({ ...prevState, friday: value }))}
          />
        </td>
        <td>
          <input
            name="exit-work-time"
            type="time"
            disabled={isDisabled.friday}
            value={entriesValues.friday}
            onChange={(e) => setEntriesValue((prevState) => ({ ...prevState, friday: e.target.value }))}
          />
        </td>
        <td>
          <input
            name="entry-work-time"
            type="time"
            disabled={isDisabled.friday}
            value={exitValues.friday}
            onChange={(e) => setExitValues((prevState) => ({ ...prevState, friday: e.target.value }))}
          />
        </td>
        <td style={{ textAlign: 'center' }}>
          <input
            name="worked-days"
            type="number"
            style={{ maxWidth: '100px' }}
            disabled={isDisabled.friday}
            value={workedDays.friday || ''}
            onChange={(e) => setWorkedDays((prevState) => ({ ...prevState, friday: Number(e.target.value) }))}
          />
        </td>
      </tr>
      <tr className="time-slots-wrapper">
        <td><p>Sabado</p></td>
        <td>
          <FlipSwitch
            isOn={isDisabled.saturday}
            setIsOn={(value) => setIsDisabled((prevState) => ({ ...prevState, saturday: value }))}
          />
        </td>
        <td>
          <input
            name="entry-work-time"
            type="time"
            disabled={isDisabled.saturday}
            value={entriesValues.saturday}
            onChange={(e) => setEntriesValue((prevState) => ({ ...prevState, saturday: e.target.value }))}
          />
        </td>
        <td>
          <input
            name="exit-work-time"
            type="time"
            disabled={isDisabled.saturday}
            value={exitValues.saturday}
            onChange={(e) => setExitValues((prevState) => ({ ...prevState, saturday: e.target.value }))}
          />
        </td>
        <td style={{ textAlign: 'center' }}>
          <input
            name="worked-days"
            type="number"
            style={{ maxWidth: '100px' }}
            disabled={isDisabled.saturday}
            value={workedDays.saturday || ''}
            onChange={(e) => setWorkedDays((prevState) => ({ ...prevState, saturday: Number(e.target.value) }))}
          />
        </td>
      </tr>
      <tr className="time-slots-wrapper">
        <td><p>Domingo</p></td>
        <td>
          <FlipSwitch
            isOn={isDisabled.sunday}
            setIsOn={(value) => setIsDisabled((prevState) => ({ ...prevState, sunday: value }))}
          />
        </td>
        <td>
          <input
            name="entry-work-time"
            type="time"
            disabled={isDisabled.sunday}
            value={entriesValues.sunday}
            onChange={(e) => setEntriesValue((prevState) => ({ ...prevState, sunday: e.target.value }))}
          />
        </td>
        <td>
          <input
            name="exit-work-time"
            type="time"
            disabled={isDisabled.sunday}
            value={exitValues.sunday}
            onChange={(e) => setExitValues((prevState) => ({ ...prevState, sunday: e.target.value }))}
          />
        </td>
        <td style={{ textAlign: 'center' }}>
          <input
            name="worked-days"
            type="number"
            style={{ maxWidth: '100px' }}
            disabled={isDisabled.sunday}
            value={workedDays.sunday || ''}
            onChange={(e) => setWorkedDays((prevState) => ({ ...prevState, sunday: Number(e.target.value) }))}
          />
        </td>
      </tr>
    </tbody>
  </table>
);

TimeSlots.propTypes = {
  entriesValues: PropTypes.objectOf(PropTypes.string),
  setEntriesValue: PropTypes.func,
  exitValues: PropTypes.objectOf(PropTypes.string),
  setExitValues: PropTypes.func,
  workedDays: PropTypes.objectOf(PropTypes.number),
  setWorkedDays: PropTypes.func,
  isDisabled: PropTypes.objectOf(PropTypes.bool),
  setIsDisabled: PropTypes.func,
};

TimeSlots.defaultProps = {
  entriesValues: {
    monday: '09:00',
    tuesday: '09:00',
    wednesday: '09:00',
    thursday: '09:00',
    friday: '09:00',
    saturday: '09:00',
    sunday: '00:00',
  },
  setEntriesValue: () => {},
  exitValues: {
    monday: '18:00',
    tuesday: '18:00',
    wednesday: '18:00',
    thursday: '18:00',
    friday: '18:00',
    saturday: '12:00',
    sunday: '00:00',
  },
  setExitValues: () => {},
  workedDays: {
    monday: 5,
    tuesday: 5,
    wednesday: 4,
    thursday: 4,
    friday: 4,
    saturday: 4,
    sunday: 4,
  },
  setWorkedDays: () => {},
  isDisabled: {
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: true,
  },
  setIsDisabled: () => {},
};

export default TimeSlots;
